import { useMemo } from 'react';
import { useObserver } from 'mobx-react';
import { formatInternationalPhoneNumber } from '../helpers/formatInternationalPhoneNumber';
import { useUserStore } from '../../../../auth/user/domain/stores/useUserStore';
import { getStateNameForAbbreviation } from '../helpers/getStateNameForAbbreviation';
import { DetailsDefaultValues } from '../types/IDetailsFormData';

export const COMMON_DEFAULT_VALUES = {
	state: '',
};

export function useDetailsDefaultValues(): DetailsDefaultValues {
	const userStore = useUserStore();

	const user = useObserver(() => userStore.user);

	return useMemo(() => {
		if (!user) {
			return COMMON_DEFAULT_VALUES;
		}

		const defaultValues: DetailsDefaultValues = {
			...COMMON_DEFAULT_VALUES,
			...user,
			phoneNumber:
				user.phoneNumber && formatInternationalPhoneNumber(user.phoneNumber),
			state: user.state && getStateNameForAbbreviation(user.state),
		};

		return defaultValues;
	}, [user]);
}
